import axios from '@/plugins/axios';

export function uploadFile(target, remote, data, successFn, progressFn) {
  var file = target.files[0];
  var formdata = new FormData();
  formdata.append(target.getAttribute('name'), file);
  if (data && typeof data === 'object') {
    Object.keys(data).forEach(key => {
      formdata.append(key, data[key]);
    });
  }
  let config = {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: progressEvent => {
      var complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
      if (progressFn) {
        progressFn(complete);
      }
    }
  };
  axios.post(remote, formdata, config).then(res => {
    if (successFn) {
      successFn(res);
    }
  });
}

export const MAX_UPLOAD_FILE_SIZE = 10;

/**
 * 校验图片是否超过指定大小
 * @param {File} file
 * @param {number} maxSize
 */
export function validateFileSize(file, maxSize) {
  // 默认10M
  let checkMaxSize = 1024 * 1024 * MAX_UPLOAD_FILE_SIZE;
  if (maxSize) {
    checkMaxSize = 1024 * 1024 * maxSize;
  }
  return file.size <= checkMaxSize;
}

/**
 * 校验文件是否为图片文件
 * @param {File} file
 */
export function checkFileIsImg(file) {
  let reg = /\.tiff$|\.tif$|\.bmp$|\.jpg$|\.jpeg$|\.gif$|\.png$/i;
  let fileName = file.name;
  return reg.test(fileName);
}
